import React from 'react';
import { useParams } from 'react-router-dom';

import Buscando from 'Component/Admin/Buscando';
import SemRegistros from 'Component/Admin/SemRegistros';
import { TransacaoLista } from 'Component/Admin/Transacao';
import Botao from 'Component/Botao';
import Paginacao from 'Component/Paginacao';
import { useRecuperarTransacoesQuery } from 'View/Service/Default/Transacoes';

const Transacoes = (): React.ReactElement => {
  const { id = 0 } = useParams();

  const {
    data: { transacoes, paginacao } = {},
    isLoading,
    isFetching,
    refetch,
  } = useRecuperarTransacoesQuery({
    scope: false,
    options: { usuario_id: id },
    sort: 'criado',
    direction: 'desc',
  });

  return (
    <React.Fragment>
      <div className="mb-3 d-flex gap-2">
        <Botao icone="arrow-clockwise" onClick={refetch} />
      </div>
      <Buscando exibir={isLoading} />
      <SemRegistros carregando={isLoading} registros={transacoes?.length} />
      <div className="bg-white shadow-sm rounded">
        {transacoes?.map((transacao) => (
          <TransacaoLista
            key={`${transacao.id}-${transacao.modificado}`}
            dados={transacao}
          />
        ))}
      </div>
      <Paginacao dados={paginacao} desabilitado={isFetching} />
    </React.Fragment>
  );
};

export default Transacoes;
